import React, { useState } from 'react';
import {
    Box,
    IconButton,
    Menu,
    MenuItem,
    Typography,
    Avatar,
    Tooltip,
    Divider,
    ListItemIcon
} from '@mui/material';
import { MenuRounded, PowerSettingsNewOutlined, ToggleOnOutlined } from '@mui/icons-material';
import MenuItemLink from '../BasvuruForm/Component/MenuItemLink';
import useGlobal from '../../../util/Global';




const UserMenu = ({ full, onLogout, menuItems }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const { t } = useGlobal();

    const handleMenuOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    if (!full.isLoggedIn) return null;


    return (

        <Box>
            <Tooltip title={full.user?.adSoyad}>
                <IconButton onClick={handleMenuOpen} sx={{ color: 'white' }}>
                    <Avatar sx={{ width: 32, height: 32 }}>
                        {full.user?.adSoyad?.[0] ?? '?'}
                    </Avatar>
                </IconButton>
            </Tooltip>
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleMenuClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            >

                <MenuItem>
                    <Typography variant="body2" sx={{ opacity: 0.8, color: 'CaptionText' }}>
                        {full.user?.adSoyad}
                    </Typography>
                </MenuItem>

                <Divider />
                {menuItems.map((item) => (
                    <MenuItem
                        key={item.label}
                        onClick={handleMenuClose}
                        component={MenuItemLink}
                        to={item.to}
                    >
                        <MenuRounded fontSize="small" sx={{ mr: 1 }} />
                        {item.label}
                    </MenuItem>
                ))}

                <MenuItem onClick={() => { handleMenuClose(); onLogout(); }}>
                    <PowerSettingsNewOutlined fontSize="small" sx={{ mr: 1 }} />
                    {t('menu.logout')}
                </MenuItem>
            </Menu>

        </Box>
    );
};

export default UserMenu;
